/* Built In Imports */
import { useEffect, useRef, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import parser from 'html-react-parser';
import forEach from 'lodash/forEach';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@components/Utility/utils';

/* Services */
// import { consoleLog } from '@components/Utility/Shared/SharedService';

let allTags = ['Readmore'];

/**
 * Renders parsed string for structured text ShortCode.
 *
 * @param {string} str - HTML string.
 * @param {string} className - Class Name
 * @param {string} region - Region of the page
 * @param {string} textAlign - Alignment of the page
 * @returns {ReactElement} Structured Text Parser Code component
 */

const StructuredTextParserRemake = ({
  sectionContent,
  str,
  mt,
  className,
  textAlign,
  region,
  lang,
  maxW,
  isOpen,
  ...props
}) => {
  const structured = useRef();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [modifiedContent, setModifiedContent] = useState('');

  useEffect(() => {
    // Function to remove the [Readmore] part from the content
    const removeReadmore = htmlContent => {
      // Use a regular expression to remove [Readmore] and everything inside the <p> tags
      const regex = /\[Readmore\]/g;
      return htmlContent.replace(regex, '<div style="height: 20px;"></div>'); // Removing the '[Readmore]' part
    };

    // Process the content to remove '[Readmore]' text
    const processedContent = removeReadmore(str);
    setModifiedContent(processedContent);
  }, [str]);

  if (textAlign && textAlign === 'center-align') {
    textAlign = 'center';
  }

  let innerText = '';
  let initialString = '';
  let startTagIndex = -1;

  // <a([^>]* )href=\"([^\"]+)\"
  const re = new RegExp('href="([^"]+)"', 'g');
  let strMatched = str?.match(re);
  if (strMatched?.length) {
    forEach(strMatched, function (matched) {
      matched = matched.replace('href=', '').replace(/"/g, '');
      str = str.replace(
        `"${matched}"`,
        `"${refineUrlDomain(matched, region, lang)}"`
      );
    });
  }

  forEach(allTags, function (tag) {
    let matched = str?.match(/\[(.*?)\]/g);
    if (matched?.length && matched[0].indexOf(tag) > -1) {
      startTagIndex = str.indexOf(matched[0]);
    }
    initialString = str;
    if (sectionContent?.fieldId === 'read-more-ys' && !isMobile) {
      startTagIndex = -1;
      initialString = initialString
        .replace('[Readmore]', '')
        .replace('[/Readmore]', '');
    }
    initialString = str?.substring(0, startTagIndex) || initialString;
    // console.log('initialString :==> ', initialString);
  });

  return (
    <Box ref={structured}>
      {!isOpen && (
        <Box
          className={className || ''}
          mx={{ base: '0', md: 'auto', lg: 'auto' }}
          mt={{ base: mt || '15px', md: mt || '15px', lg: mt || '15px' }}
          maxW={{
            base: '100%',
            md: maxW || '515px',
            lg:
              maxW || sectionContent?.fieldId === 'read-more-ys'
                ? '590px'
                : '600px',
            xl:
              maxW || sectionContent?.fieldId === 'read-more-ys'
                ? '590px'
                : '100%',
          }}
          textAlign={textAlign || 'left'}
          fontSize={'1rem'}
          px={0}
          {...props}
        >
          {initialString && parser(initialString)}
        </Box>
      )}

      {isOpen && (
        <Box
          fontFamily={'FedraSansStd-book'}
          pb="30px"
          className={`${className || ''} list-content`}
          textAlign={textAlign || 'left'}
          {...props}
          dangerouslySetInnerHTML={{ __html: modifiedContent }}
        />
      )}
      <style>
        {`
          .list-content ul li{
            list-style-type: disc; 
          }
            
          .list-content a, .list-content a strong{
            text-decoration: underline;
            color: #0a68f8;
            font-weight: 450 !important;
          }
          .list-content ul { padding-left: 20px; } 
        `}
      </style>
    </Box>
  );
};

export default StructuredTextParserRemake;
